import { User } from "../interfaces/user";
import { stringUtils } from "./string-utils";

export const getUserFullName = (user: User, fullMiddleName: boolean = false): string => {
  if (!user) return '';

  const middle = user.middle_name
    ? (fullMiddleName
      ? user.middle_name
      : `${user.middle_name.charAt(0).toUpperCase()}.`)
    : '';

  const fullName = [user.first_name, middle, user.last_name]
    .filter(Boolean)
    .join(' ');

  return stringUtils(fullName);
}

export const computeAge = (birthdate: string | Date): number => {
  const birth = typeof birthdate === 'string' ? new Date(birthdate) : birthdate;
  const today = new Date();

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export const getStudentSearchText = (user: User): string => {
  const name = getUserFullName(user, true);
  const studentNumber = String(user.student?.student_id ?? '').trim();
  const lrn = String(user.student?.lrn ?? '').trim();

  return [name, studentNumber, lrn]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export const matchesStudentSearch = (user: User, query: string): boolean => {
  const q = query.toLowerCase().trim();
  return !q || getStudentSearchText(user).includes(q);
}
